module.exports = __webpack_public_path__ + "static/Bat-27a6977e0d1ca08e1613bc4fff8968a1.jpg";